// extracted by mini-css-extract-plugin
export default {"statistic__wrap":"Statistics_statistic__wrap__5Xg7z","statistic__text":"Statistics_statistic__text__DOJvE"};